import { AfterViewInit, Directive, OnInit } from '@angular/core';
import { MnpCrudService, MnpFilter, MnpReadRequest } from '../api';
import { MnpFieldsService } from './mnp-fields';
import { filter, finalize } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocalTable } from './local-table';

@Directive()
export abstract class MnpTable<T> extends LocalTable<T> implements OnInit, AfterViewInit {
	private isRefreshing = false;

	protected constructor(
		public readonly dataService: MnpCrudService<T>,
		public readonly fieldsService: MnpFieldsService
	) {
		super();
	}

	refresh(): void {
		this.isRefreshing = true;
		this.dataService.activePage = 0;
		this.dataService.pageSize = this.defaultPageSize;
		this.reload();
	}

	reload(): void {
		this.loading$.next(true);
		this.dataService
			.read(this.getReadParamsMnp())
			.pipe(
				filter(() => !this.isRefreshing),
				takeUntilDestroyed(this.destroyRef),
				finalize(() => {
					this.isRefreshing = false;
					this.loading$.next(false);
				})
			)
			.subscribe({
				next: (resp) => {
					this.tRows = resp?.Data ?? [];
					this.total = resp?.Total ?? 0;

					if (this.incorrectPagination() && this.dataService.activePage !== 0) {
						this.dataService.activePage = Math.ceil(this.total / this.dataService.pageSize) - 1;
						this.reload();
					}
				},
				error: () => {
					this.tRows = [];
					this.total = 0;
				},
			});
	}

	getReadParamsMnp(): MnpReadRequest {
		return {
			offset: this.dataService.pageSize * this.dataService.activePage,
			limit: this.dataService.pageSize ?? 25,
			active: '',
			direction: '',
			filter: this.toFilter(this.filtersForm.getRawValue()),
		};
	}

	toFilter(params: Record<string, any>): MnpFilter[] {
		return Object.entries(params)
			.map(([key, value]) => {
				return {
					key,
					value: Array.isArray(value) ? value.join(',') : value,
				};
			})
			.filter((el) => !!el.value);
	}
}
